// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KDUzv","label":"styles_label__Vxu-d"};